module.exports = __webpack_public_path__ + "static/media/top-slide-5.0c3eb9c3.avif";